(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["readywear-signup-popup"]) return;
  try {
    
(() => {
  const init = () => {
    const modal = document.getElementById('rw-signup');
    if (!modal || modal.dataset.initialized) return;
    modal.dataset.initialized = 'true';
    document.addEventListener('keydown', e => { if (e.key === 'Tab') modal.dataset.keyboard = 'true'; });
    modal.addEventListener('pointerdown', () => delete modal.dataset.keyboard);
    const key = 'readywear_signup_v2', week = 604800000, month = 2592000000, fade = 140;
    const preview = window.Shopify?.designMode || new URLSearchParams(location.search).get('rw_popup_preview') === '1';
    const loggedIn = modal.dataset.rwCustomer === 'true';
    const cookie = name => document.cookie.split('; ').find(v => v.startsWith(name + '='))?.slice(name.length + 1);
    const read = (name, session = false) => { try { return (session ? sessionStorage : localStorage).getItem(name) || decodeURIComponent(cookie(name) || ''); } catch { return decodeURIComponent(cookie(name) || ''); } };
    const write = (name, value, session = false, age = 31536000) => {
      try { (session ? sessionStorage : localStorage).setItem(name, value); } catch {}
      document.cookie = name + '=' + encodeURIComponent(value) + '; Path=/; SameSite=Lax; Secure' + (session ? '' : '; Max-Age=' + age);
    };
    const remove = (name, session = false) => { try { (session ? sessionStorage : localStorage).removeItem(name); } catch {} document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure'; };
    let state; try { state = JSON.parse(read(key) || '{}'); } catch { state = {}; }
    if (!preview && !state.status) {
      const old = read('readywear_signup_v1');
      if (old === 'claimed') state = {status:'claimed'};
      if (old === 'dismissed') state = {status:'dismissed', until:Date.now() + week};
      if (state.status) write(key, JSON.stringify(state));
    }
    const save = status => { if (preview) return; const duration = status === 'dismissed' ? week : month; state = {status, until:Date.now() + duration}; write(key, JSON.stringify(state), false, duration / 1000); };
    const suppressed = () => ((['claimed','subscribed','dismissed'].includes(state.status) && (!state.until || state.until > Date.now())) || read(key + '_shown', true) === '1');
    const first = modal.querySelector('[data-rw-art]'), fields = modal.querySelector('#rw-signup-fields'), img = first.querySelector('img');
    let priorFocus, scrollY, bodyStyle, timer, triggered = false;
    const stop = () => { clearTimeout(timer); window.removeEventListener('scroll', onScroll); document.removeEventListener('visibilitychange', attempt); };
    const open = () => {
      if (modal.open) return;
      priorFocus = document.activeElement; scrollY = window.scrollY; bodyStyle = document.body.getAttribute('style');
      const gap = window.innerWidth - document.documentElement.clientWidth;
      const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      Object.assign(document.body.style, {position:'fixed',top:-scrollY + 'px',left:'0',right:'0',width:'auto',paddingRight:padding + gap + 'px'});
      modal.showModal();
      if (!preview) write(key + '_shown', '1', true);
      stop();
    };
    const restore = () => {
      if (bodyStyle === null) document.body.removeAttribute('style'); else if (bodyStyle !== undefined) document.body.setAttribute('style', bodyStyle);
      if (scrollY !== undefined) { const root = document.documentElement, behavior = root.style.scrollBehavior; root.style.scrollBehavior = 'auto'; window.scrollTo(0, scrollY); root.style.scrollBehavior = behavior; }
      priorFocus?.isConnected && priorFocus.focus({preventScroll:true});
    };
    modal.addEventListener('close', restore);
    const close = () => { if (!['claimed','subscribed'].includes(state.status)) save('dismissed'); stop(); if (modal.open) modal.close(); };
    modal.addEventListener('cancel', e => { e.preventDefault(); close(); });
    const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
    const swap = async change => { modal.classList.add('rw-switching'); await wait(fade); change(); modal.scrollTop = 0; requestAnimationFrame(() => modal.classList.remove('rw-switching')); };
    const showFields = async () => {
      await Promise.all([...fields.querySelectorAll('img')].map(async image => { const preload = new Image(); preload.src = image.src; await preload.decode().catch(() => {}); }));
      await swap(() => { first.hidden = true; fields.hidden = false; });
      modal.querySelector('#rw-signup-email')?.focus({preventScroll:true});
    };
    const setFormMessage = message => { const status = modal.querySelector('[data-rw-inline-error]'); if (status) status.textContent = message; };
    modal.addEventListener('click', async e => {
      const r = modal.getBoundingClientRect();
      if (e.target === modal && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) { close(); return; }
      if (e.target.closest('[data-rw-dismiss]')) { close(); return; }
      if (e.target.closest('#rw-signup-reveal')) { await showFields(); return; }
      const copy = e.target.closest('[data-rw-copy]');
      if (copy) {
        const code = modal.querySelector('#rw-discount-code'), status = modal.querySelector('[data-rw-copy-status]');
        try { await navigator.clipboard.writeText(code.value); status.textContent = 'COPIED!'; }
        catch { code.focus({preventScroll:true}); code.select(); status.textContent = 'SELECT + COPY'; }
        clearTimeout(modal._rwCopyTimer); modal._rwCopyTimer = setTimeout(() => { if (status) status.textContent = ''; }, 1600);
        return;
      }
      if (e.target.closest('[data-rw-shop]')) { save('claimed'); stop(); if (modal.open) modal.close(); }
    });

    const signupForm = modal.querySelector('form');
    const signupEmail = modal.querySelector('#rw-signup-email');
    signupEmail?.addEventListener('input', () => setFormMessage(''));
    signupEmail?.addEventListener('invalid', () => setFormMessage('ENTER A VALID EMAIL ADDRESS'));
    const submitSignup = async () => {
      if (signupForm.dataset.busy || !signupForm.reportValidity()) return;
      signupForm.dataset.busy = 'true';
      const submit = signupForm.querySelector('[type="submit"]');
      submit?.setAttribute('aria-disabled', 'true');
      setFormMessage('');
      write(key + '_pending', String(Date.now()), true);
      try {
        const response = await fetch(signupForm.action, {method:'POST', body:new FormData(signupForm), credentials:'same-origin', redirect:'follow'});
        const html = await response.text();
        const result = new DOMParser().parseFromString(html, 'text/html');
        const success = result.querySelector('#rw-signup [data-rw-success]');
        if (!response.ok || !success) {
          const returnedError = result.querySelector('#rw-signup [data-rw-errors], #rw-signup .errors')?.textContent?.trim();
          setFormMessage(returnedError || 'SIGNUP FAILED. PLEASE TRY AGAIN.');
          remove(key + '_pending', true);
          return;
        }
        const successImage = success.querySelector('img');
        if (successImage?.src) { const preload = new Image(); preload.src = successImage.src; await preload.decode().catch(() => {}); }
        const confirmed = document.importNode(success, true);
        await swap(() => { fields.replaceChildren(confirmed); first.hidden = true; fields.hidden = false; });
        save('claimed');
        remove(key + '_pending', true);
        confirmed.focus({preventScroll:true});
      } catch {
        setFormMessage('SIGNUP FAILED. PLEASE TRY AGAIN.');
        remove(key + '_pending', true);
      } finally {
        submit?.removeAttribute('aria-disabled');
        delete signupForm.dataset.busy;
      }
    };
    signupForm?.addEventListener('submit', e => { e.preventDefault(); submitSignup(); });
    signupForm?.querySelector('[type="submit"]')?.addEventListener('click', e => { e.preventDefault(); submitSignup(); });
    const pending = Number(read(key + '_pending', true));
    if (pending && Date.now() - pending < 1800000 && (modal.querySelector('[data-rw-success]') || modal.querySelector('[data-rw-errors]'))) {
      showFields().then(() => { open(); if (modal.querySelector('[data-rw-success]')) { save('claimed'); remove(key + '_pending', true); modal.querySelector('[data-rw-success]').focus({preventScroll:true}); } });
      return;
    }
    if (pending && Date.now() - pending >= 1800000) remove(key + '_pending', true);
    const footer = document.getElementById('ReadywearFooterNewsletter') || document.getElementById('ContactFooter');
    footer?.addEventListener('submit', () => { write(key + '_footer_pending', String(Date.now()), true); });
    const footerPending = Number(read(key + '_footer_pending', true));
    if (footerPending && Date.now() - footerPending < 1800000 && footer?.querySelector('.newsletter-form__message--success, p.readywear-footer__message')) { save('subscribed'); remove(key + '_footer_pending', true); }
    const excluded = /\/(cart|checkout|account|challenge|password)(\/|$)/.test(location.pathname);
    function attempt() {
      if (!triggered || !modal.isConnected || modal.open || (!preview && (suppressed() || excluded || loggedIn))) return;
      if (document.visibilityState !== 'visible' || !img.complete || !img.naturalWidth) return;
      if (document.querySelector('dialog[open],cart-drawer.active,menu-drawer details[open],details-modal details[open],quick-add-modal[open]')) return;
      open();
    }
    function onScroll() {
      const distance = document.documentElement.scrollHeight - window.innerHeight;
      if (distance > 0 && window.scrollY / distance >= .35) triggered = true;
      attempt();
    }
    if (!preview && (suppressed() || excluded || loggedIn)) return;
    img.addEventListener('load', attempt, {once:true});
    document.addEventListener('visibilitychange', attempt);
    window.addEventListener('scroll', onScroll, {passive:true});
    if (preview) { triggered = true; attempt(); } else { timer = setTimeout(() => { triggered = true; attempt(); }, 5000); onScroll(); }
    document.addEventListener('shopify:section:unload', e => { if (e.target.contains(modal)) { stop(); if(modal.open) modal.close(); } }, {once:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();
})();
